export const GlassConstants =
{
    slotProps: (hoveredIndex, titleOffset) => {
        return {
            paper: {
                sx: {
                    minWidth: '150px',
                        width: 'fit-content',
                        backgroundColor: 'color-mix(in srgb, #bbbbbc 12%, transparent)',
                        backdropFilter: 'blur(15px) saturate(100%)',
                        WebkitBackdropFilter: 'blur(15px) saturate(100%)',
                        borderRadius: '12px',
                        border: 'none',
                        boxShadow: `
                            inset 0 0 0 1px color-mix(in srgb, #fff 3%, transparent),
                            inset 1.8px 3px 0px -2px color-mix(in srgb, #fff 27%, transparent),
                            inset -2px -2px 0px -2px color-mix(in srgb, #fff 24%, transparent),
                            inset -3px -8px 1px -6px color-mix(in srgb, #fff 18%, transparent),
                            inset -0.3px -1px 4px 0px color-mix(in srgb, #000 4.8%, transparent),
                            inset -1.5px 2.5px 0px -2px color-mix(in srgb, #000 8%, transparent),
                            inset 0px 3px 4px -2px color-mix(in srgb, #000 8%, transparent),
                            inset 2px -6.5px 1px -4px color-mix(in srgb, #000 4%, transparent),
                            0px 1px 5px 0px color-mix(in srgb, #000 4%, transparent),
                            0px 6px 16px 0px color-mix(in srgb, #000 3.2%, transparent)
                        `,
                        overflow: 'visible',
                        position: 'relative',
                        pointerEvents: 'auto',
                        '& .MuiList-root': {
                        padding: '8px',
                            position: 'relative',
                    },
                    '&::before': {
                        content: '""',
                            position: 'absolute',
                            top: 0,
                            left: '8px',
                            right: '8px',
                            height: '40px',
                            backgroundColor: 'color-mix(in srgb, #bbbbbc 18%, transparent)',
                            backdropFilter: 'blur(20px) saturate(110%) brightness(1.15)',
                            WebkitBackdropFilter: 'blur(20px) saturate(110%) brightness(1.15)',
                            borderRadius: '8px',
                            boxShadow: `
                                inset 0 0 0 1px color-mix(in srgb, #fff 8%, transparent),
                                inset 1.5px 2px 0px -1px color-mix(in srgb, #fff 35%, transparent),
                                inset -1.5px -1.5px 0px -1px color-mix(in srgb, #fff 28%, transparent),
                                inset -2px -6px 1px -4px color-mix(in srgb, #fff 20%, transparent),
                                inset -0.2px -0.8px 3px 0px color-mix(in srgb, #000 6%, transparent),
                                inset -1px 2px 0px -1px color-mix(in srgb, #000 10%, transparent),
                                inset 0px 2px 3px -1px color-mix(in srgb, #000 10%, transparent),
                                inset 1.5px -5px 1px -3px color-mix(in srgb, #000 5%, transparent),
                                0px 1px 4px 0px color-mix(in srgb, #000 8%, transparent),
                                0px 4px 12px 0px color-mix(in srgb, #000 6%, transparent)
                            `,
                            transform: hoveredIndex !== null ? `translateY(${8 + (hoveredIndex + titleOffset) * 42}px)` : 'translateY(8px)',
                            opacity: hoveredIndex !== null ? 1 : 0,
                            transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease',
                            pointerEvents: 'none',
                            zIndex: 0,

                    }
                }
            },
            backdrop: {
                sx: {
                    pointerEvents: 'none', // Make backdrop click-through
                        backgroundColor: 'transparent',
                }
            },
            root: {
                style: {
                    zIndex: 10001,
                        pointerEvents: 'none', // Make root click-through
                }
            }
        }
    },
    sx: (hoveredIndex, index) => {
        return {
            color: 'white',
            borderRadius: '8px',
            margin: '1px 0',
            minHeight: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            position: 'relative',
            zIndex: 1,
            backgroundColor: 'transparent !important',
            padding: '0 12px',
            fontSize: hoveredIndex === index ? '1.05em' : '1em',
            fontWeight: hoveredIndex === index ? 500 : 400,
            transition: 'font-size 0.2s cubic-bezier(0.4, 0, 0.2, 1), font-weight 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            pointerEvents: 'auto', // Menu items are clickable
        };
    },
    titleStyle: {
        color: '#c0c0c0',
        fontSize: '1.2em',
        fontWeight: 500,
        padding: '4px 12px 6px 12px',
        margin: '0 0 4px 0',
        borderBottom: '1px solid color-mix(in srgb, #fff 20%, transparent)',
        userSelect: 'none',
        pointerEvents: 'none',
    }
}